module.exports = __webpack_public_path__ + "img/LocumWallet logo_icon blue.2e955b61.png";